import { OfflineAction } from "../types";

export const createOfflineMeta = (username: string, url: string, method = "GET", body?: any): OfflineAction["meta"] => ({
    offline: { 
        effect: { username, url, method, body }
    }
});
